import React from 'react';

import { Tag } from '@rikstv/shared-components';

import { ReactComponent as ImdbIcon } from './imdb.svg';

import './ImdbBadge.scss';

interface Props {
  imdbRating: string | undefined;
}

const ImdbBadge: React.FunctionComponent<Props> = ({ imdbRating }) => {
  if (!imdbRating) {
    return null;
  }
  return (
    <>
      <ImdbIcon className="imdb-badge__svg" />
      <Tag>{imdbRating}</Tag>
    </>
  );
};

export { ImdbBadge };
